import { render, staticRenderFns } from "./ConsumerProfileForm.vue?vue&type=template&id=31856ed1&"
import script from "./ConsumerProfileForm.vue?vue&type=script&lang=js&"
export * from "./ConsumerProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports